var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _rect, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _rect2, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _rect3, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _rect4, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedalApproved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 418,
    viewBox: "0 0 418 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.6 417.2C323.807 417.2 417.2 323.807 417.2 208.6C417.2 93.3934 323.807 0 208.6 0C93.3934 0 0 93.3934 0 208.6C0 323.807 93.3934 417.2 208.6 417.2Z",
    fill: "#12BBF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.6 393.7C310.828 393.7 393.7 310.828 393.7 208.6C393.7 106.372 310.828 23.5 208.6 23.5C106.372 23.5 23.5 106.372 23.5 208.6C23.5 310.828 106.372 393.7 208.6 393.7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.3 318.6C174.3 318.8 174.3 318.9 174.3 319L174.1 319.9L168.5 347.6C168.5 347.9 168.4 348.3 168.3 348.6C168.1 349.3 167.9 349.9 167.6 350.5C155.3 346.9 143.7 341.7 132.9 335.2L131.5 334.7C131.3 334.6 131.1 334.6 131 334.5C131.1 334.4 131.1 334.2 131.2 334.1C131.3 333.9 131.4 333.8 131.5 333.7L139.3 319.5L144.4 310.2C146.3 307.8 148.5 306.4 150.8 305.7C154.6 304.5 158.7 305.2 162 306.3C162.3 306.4 162.6 306.5 162.8 306.6C163.1 306.7 163.4 306.8 163.6 306.9C163.8 307 164 307.1 164.2 307.2C165.7 307.8 167.2 308.7 168.6 309.6C168.6 309.6 168.6 309.6 168.7 309.6C171.9 311.7 174.3 314.7 174.3 318.6Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.2 351.2C169.4 351 168.5 350.8 167.7 350.5C155.4 346.9 143.8 341.7 133 335.2L167.5 348.2C167.8 348.3 168.1 348.4 168.3 348.6C169.3 349.2 169.9 350.2 170.2 351.2Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M161.9 341.6C161.5 342.8 156.2 341.9 150.1 339.6C144 337.3 139.5 334.5 139.9 333.4C140.3 332.3 145.6 333.1 151.7 335.4C157.8 337.7 162.4 340.5 161.9 341.6Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M159.5 314.4C169.1 316.9 171.4 326.1 171.7 331.7L174.5 318.1C175 313 168.1 308.4 162.9 306.5C157.7 304.5 148.4 304.5 145.4 308.6L138.5 320.3C142.2 317 147.3 311.2 159.5 314.4Z",
    fill: "url(#paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.501 353L228.301 353.4L219.701 355.9C217.901 356 216.101 356.1 214.401 356.2C213.501 356.2 212.701 356.3 211.801 356.3C210.701 356.3 209.501 356.3 208.401 356.3C207.801 356.3 207.201 356.3 206.601 356.3L206.501 356L206.001 354.5L205.401 352.6L205.301 352.3L220.301 347.9L227.301 345.8L227.801 347.6L228.401 349.5L229.201 352.1L229.501 353Z",
    fill: "#D5C691"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.297 352.25L206.402 355.99L228.363 349.502L227.259 345.762L205.297 352.25Z",
    fill: "#A5986E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232 344.2L201.3 353.9C198.4 354.8 195.8 352 195.6 348L191.3 321.5C191.2 312.9 198.2 309 203.5 307.3C208.8 305.6 216.5 304.9 220.2 310.1L233.3 336.2C235.4 339.5 234.9 343.3 232 344.2Z",
    fill: "url(#paint4_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M238.3 341.2C238.3 343 237.2 344.6 235.4 345.2L227.9 347.6L206 354.5L200.9 356.1C198.7 356 196.6 355.8 194.5 355.6C194.1 355.1 193.8 354.6 193.6 354C193.5 353.6 193.4 353.2 193.4 352.7C193.4 351.1 194.3 349.6 195.8 348.9C196 348.8 196.1 348.8 196.3 348.7L232.9 337.2C233.2 337.1 233.5 337 233.8 337C235.7 336.8 237.6 338 238.2 339.9C238.3 340.4 238.3 340.8 238.3 341.2Z",
    fill: "url(#paint5_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M224.4 335.5C224.8 336.7 220.1 339.2 213.9 341.2C207.7 343.1 202.4 343.8 202 342.6C201.6 341.4 206.3 338.9 212.5 336.9C218.7 334.9 224 334.3 224.4 335.5Z",
    fill: "url(#paint6_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M205.701 315.6C214.801 311.6 222.301 317.5 226.001 321.7L219.801 309.3C217.101 305 208.801 305.7 203.501 307.3C198.201 308.9 190.801 314.7 191.101 319.8L192.801 333.2C193.701 328.3 194.101 320.6 205.701 315.6Z",
    fill: "url(#paint7_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M235 353.8C234.1 354 233.2 354.1 232.4 354.3C228.2 355 224 355.5 219.8 355.8C218 355.9 216.2 356 214.5 356.1C213.6 356.1 212.8 356.2 211.9 356.2C213.4 355.2 215.1 354.5 216.8 353.9L220.1 352.8C223.2 351.8 226.3 351.6 229.3 352C231.2 352.4 233.1 353 235 353.8Z",
    fill: "#5A95B7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M232.3 354.3C228.1 355 223.9 355.5 219.7 355.8C217.9 355.9 216.1 356 214.4 356.1C215.3 355.7 216.2 355.3 217.2 355L220.3 354C223 353.2 225.7 352.9 228.3 353.3C229.6 353.5 231 353.8 232.3 354.3Z",
    fill: "url(#paint8_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M330.999 134.2C345.299 156.6 353.499 183.3 353.499 211.8C353.499 291.8 288.599 356.7 208.599 356.7C128.599 356.7 63.6992 291.8 63.6992 211.8C63.6992 181.5 72.9992 153.4 88.8992 130.2",
    stroke: "#B2DEF4",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M397.801 208.6C397.801 218.5 389.101 227.5 387.601 236.9C386.101 246.6 391.601 257.9 388.601 267C385.601 276.3 374.501 282.2 370.101 290.8C365.701 299.5 367.401 311.9 361.701 319.7C356.001 327.6 343.601 329.8 336.801 336.6C329.901 343.5 327.701 355.8 319.901 361.5C312.101 367.2 299.601 365.5 291.001 369.9C282.401 374.3 276.501 385.4 267.201 388.4C258.101 391.4 246.801 385.9 237.101 387.4C227.701 388.9 218.601 397.6 208.801 397.6C198.901 397.6 189.901 388.9 180.501 387.4C170.801 385.9 159.501 391.4 150.401 388.4C141.101 385.4 135.201 374.3 126.601 369.9C117.901 365.5 105.501 367.2 97.7008 361.5C89.8008 355.8 87.6008 343.4 80.8008 336.6C73.9008 329.7 61.6008 327.5 55.9008 319.7C50.2008 311.9 51.9008 299.4 47.5008 290.8C43.1008 282.2 32.0008 276.3 29.0008 267C26.0008 257.9 31.5008 246.6 30.0008 236.9C28.5008 227.5 19.8008 218.4 19.8008 208.6C19.8008 198.7 28.5008 189.7 30.0008 180.3C31.5008 170.6 26.0008 159.3 29.0008 150.2C32.0008 140.9 43.1008 135 47.5008 126.4C51.9008 117.7 50.2008 105.3 55.9008 97.5C61.6008 89.6 74.0008 87.4 80.8008 80.6C87.7008 73.7 89.9008 61.4 97.7008 55.7C105.501 50 118.001 51.7 126.601 47.3C135.201 42.9 141.101 31.8 150.401 28.8C159.501 25.8 170.801 31.3 180.501 29.8C189.901 28.3 199.001 19.6 208.801 19.6C218.701 19.6 227.701 28.3 237.101 29.8C246.801 31.3 258.101 25.8 267.201 28.8C276.501 31.8 282.401 42.9 291.001 47.3C299.701 51.7 312.101 50 319.901 55.7C327.801 61.4 330.001 73.8 336.801 80.6C343.701 87.5 356.001 89.7 361.701 97.5C367.401 105.3 365.701 117.8 370.101 126.4C374.501 135 385.601 140.9 388.601 150.2C391.601 159.3 386.101 170.6 387.601 180.3C389.001 189.7 397.801 198.8 397.801 208.6Z",
    stroke: "white",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139 190.7L132.1 193.1C131.2 193.4 130.4 194.2 130.2 195.2L128.3 202.3C127.6 204.7 124.5 205.3 123 203.3L118.6 197.4C118 196.6 117 196.2 116.1 196.2L108.8 196.5C106.3 196.6 104.8 193.8 106.2 191.8L110.4 185.8C111 185 111.1 183.9 110.7 183L108.1 176.1C107.2 173.8 109.4 171.4 111.8 172.1L118.8 174.2C119.8 174.5 120.8 174.3 121.6 173.7L127.3 169.1C129.3 167.5 132.2 168.9 132.2 171.4L132.4 178.7C132.4 179.7 132.9 180.6 133.8 181.2L139.9 185.2C141.7 186.7 141.3 189.8 139 190.7Z",
    fill: "#FFE629"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9999 221.4L51.9999 222.8C51.4999 223 50.9999 223.4 50.8999 224L49.7999 228.1C49.3999 229.5 47.5999 229.8 46.6999 228.7L44.0999 225.3C43.7999 224.8 43.1999 224.6 42.5999 224.6L38.3999 224.8C36.9999 224.9 36.0999 223.3 36.8999 222.1L39.2999 218.6C39.5999 218.1 39.6999 217.5 39.4999 217L37.9999 213C37.4999 211.7 38.6999 210.3 40.0999 210.7L44.0999 211.9C44.5999 212.1 45.1999 212 45.6999 211.6L48.9999 209C50.0999 208.1 51.7999 208.9 51.7999 210.3L51.8999 214.5C51.8999 215.1 52.1999 215.6 52.6999 215.9L56.1999 218.2C57.4999 219.1 57.2999 220.9 55.9999 221.4Z",
    fill: "#FFE629"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M217.6 64.7L213.4 62.9C212.8 62.7 212.2 62.7 211.7 63L207.8 65.4C206.5 66.2 204.8 65.2 204.9 63.6L205.3 59C205.4 58.4 205.1 57.8 204.6 57.4L201.1 54.5C199.9 53.5 200.4 51.6 201.9 51.2L207.7 49.1C208.3 49 207.5 49.7 207.7 49.1L209.4 44.9C210 43.5 212 43.3 212.8 44.6L215.1 48.5C215.4 49 216 49.4 216.6 49.4L221.2 49.7C222.8 49.8 223.5 51.6 222.5 52.8L219.5 56.2C219.1 56.7 218.9 57.3 219.1 57.9L220.2 62.3C220.5 64 219 65.3 217.6 64.7Z",
    fill: "#FFE629"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.199 88.6001L103.999 86.8001C103.399 86.6001 102.799 86.6001 102.299 86.9001L98.3993 89.3001C97.0993 90.1001 95.3993 89.1001 95.4993 87.5001L95.8993 82.9001C95.9993 82.3001 95.6993 81.7001 95.1993 81.3001L91.6993 78.4001C90.4993 77.4001 90.9993 75.5001 92.4993 75.1001L98.2993 73.0001C98.8993 72.9001 98.0993 73.6001 98.2993 73.0001L99.9993 68.8001C100.599 67.4001 102.599 67.2001 103.399 68.5001L105.699 72.4001C105.999 72.9001 106.599 73.3001 107.199 73.3001L111.799 73.6001C113.399 73.7001 114.099 75.5001 113.099 76.7001L110.099 80.1001C109.699 80.6001 109.499 81.2001 109.699 81.8001L110.799 86.2001C111.099 87.9001 109.599 89.2001 108.199 88.6001Z",
    fill: "#FFE629"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M374.5 263.6L370.3 261.8C369.7 261.6 369.1 261.6 368.6 261.9L364.7 264.3C363.4 265.1 361.7 264.1 361.8 262.5L362.2 257.9C362.3 257.3 362 256.7 361.5 256.3L358 253.4C356.8 252.4 357.3 250.5 358.8 250.1L364.6 248C365.2 247.9 364.4 248.6 364.6 248L366.3 243.8C366.9 242.4 368.9 242.2 369.7 243.5L372 247.4C372.3 247.9 372.9 248.3 373.5 248.3L378.1 248.6C379.7 248.7 380.4 250.5 379.4 251.7L376.4 255.1C376 255.6 375.8 256.2 376 256.8L377.1 261.2C377.5 262.9 376 264.2 374.5 263.6Z",
    fill: "#FFE629"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M329.199 110L324.999 108.2C324.399 108 323.799 108 323.299 108.3L319.399 110.7C318.099 111.5 316.399 110.5 316.499 108.9L316.899 104.3C316.999 103.7 316.699 103.1 316.199 102.7L312.699 99.8C311.499 98.8 311.999 96.9 313.499 96.5L317.999 95.5C318.599 95.4 319.099 94.9 319.299 94.4L320.999 90.2C321.599 88.8 323.599 88.6 324.399 89.9L326.699 93.8C326.999 94.3 327.599 94.7 328.199 94.7L332.799 95C334.399 95.1 335.099 96.9 334.099 98.1L331.099 101.5C330.699 102 330.499 102.6 330.699 103.2L331.799 107.6C332.199 109.4 330.699 110.6 329.199 110Z",
    fill: "#FFE629"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6999 153.2L64.2999 156C63.3999 156.4 62.7999 157.1 62.5999 158.1L61.1999 164.9C60.6999 167.2 57.7999 168 56.2999 166.2L51.6999 161C51.0999 160.3 50.1999 159.9 49.1999 160L42.2999 160.8C39.8999 161.1 38.2999 158.5 39.4999 156.5L42.9999 150.5C43.4999 149.7 43.4999 148.7 43.0999 147.8L40.1999 141.5C39.1999 139.4 41.0999 137 43.3999 137.5L50.1999 139C51.0999 139.2 52.0999 138.9 52.7999 138.3L57.8999 133.6C59.5999 132 62.4999 133.1 62.6999 135.4L63.2999 142.3C63.3999 143.2 63.8999 144.1 64.7999 144.5L70.8999 147.9C72.9999 149.3 72.8999 152.3 70.6999 153.2Z",
    fill: "#FFE629"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M121.501 137.8C118.001 137.7 116.101 136.3 115.701 133.5C115.401 131.3 115.201 129.2 115.001 127.3C114.801 125.4 114.701 123.7 114.801 122.2C114.901 120.7 115.301 119.6 116.101 119C116.901 118.3 117.801 117.9 119.001 117.8C120.101 117.7 122.101 117.5 124.901 117.5C126.601 108.7 128.501 100 130.601 91.4C132.701 82.8 134.801 74.7 136.901 67C137.801 64.1 139.501 62.2 142.101 61.2C144.301 60.5 146.601 59.9 148.901 59.3C151.301 58.7 153.501 58.3 155.401 58.1C156.601 57.9 157.701 57.8 158.601 57.8C159.601 57.7 160.401 57.7 161.201 57.7C163.901 57.6 166.101 58.8 167.901 61.3C171.201 66.2 175.301 72.7 180.101 80.9C185.001 89 189.901 98 194.901 108C196.301 107.7 197.301 107.5 198.101 107.4C198.901 107.3 199.401 107.1 199.801 107.1C200.201 107 200.401 107 200.601 106.9C200.701 106.9 200.801 106.9 200.901 106.9C203.401 106.6 205.101 107.6 206.001 110.1C206.901 112.2 207.501 114.7 207.901 117.6C208.001 118.3 208.101 119 208.201 119.7C208.301 120.4 208.301 121.2 208.201 122C208.201 123.8 207.801 125 207.101 125.8C206.401 126.6 205.301 127.2 203.901 127.5C204.701 129.4 205.501 131.2 206.201 132.9C206.901 134.6 207.501 136.1 208.001 137.5C208.401 138.5 208.601 139.2 208.701 139.6C208.801 140 208.901 140.3 208.901 140.6C209.201 142.8 208.301 144.3 206.301 145.1C203.801 146.2 201.201 147.1 198.601 148C195.901 148.8 193.201 149.4 190.401 149.7C188.901 149.9 187.601 149.7 186.801 149C185.901 148.4 185.201 147.3 184.601 145.8L179.301 132.8C174.401 133.7 169.501 134.4 164.501 135C161.301 135.4 158.201 135.7 155.001 136.1C151.801 136.4 148.801 136.7 145.701 136.9C145.401 139.5 145.201 142 144.901 144.4C144.701 146.8 144.501 149.2 144.301 151.5C144.101 154.5 142.701 156.2 139.801 156.5C137.501 156.8 134.801 156.9 131.801 156.7C128.801 156.6 126.101 156.3 123.801 155.9C121.601 155.5 120.301 154.2 120.001 152C120.001 151.7 120.001 151.4 120.001 151.1C120.001 150.8 120.001 150.1 120.101 149.3C120.201 147.9 120.301 146.2 120.601 144.2C120.801 142 121.101 140 121.501 137.8ZM148.801 114.8C152.301 114.4 155.901 113.9 159.401 113.5C162.901 113.1 166.501 112.6 170.101 112C167.801 107 165.401 102 162.901 97.1C160.401 92.2 157.701 87.5 155.001 83.2C153.801 88.8 152.701 94.2 151.701 99.4C150.601 104.5 149.701 109.7 148.801 114.8Z",
    fill: "#E5225C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M278.402 160.7C275.502 159.8 273.902 158.8 273.402 157.6C272.902 156.4 272.902 154.6 273.202 152.3C269.302 154.5 265.302 156 261.102 156.9C256.902 157.8 252.602 157.9 248.102 157.2C243.102 156.4 238.702 155 235.002 152.7C231.302 150.5 228.202 147.7 225.802 144.3C223.402 140.9 221.802 137.2 220.902 133C220.002 128.8 220.002 124.4 220.702 119.6C221.702 112.9 223.902 106.9 227.302 101.5C230.702 96.1 234.902 91.6 239.702 88C244.502 84.3 249.802 81.7 255.502 80C261.202 78.3 266.902 77.9 272.502 78.8C277.302 79.5 281.802 81.2 285.902 83.7C286.402 81.7 287.002 80.5 287.802 79.9C288.502 79.3 289.602 79.1 291.102 79.4C292.902 79.7 295.202 80.2 298.102 81.1C301.002 82 303.602 82.9 306.002 84C307.202 84.5 308.302 85 309.102 85.6C310.002 86.2 310.702 86.9 311.202 87.7C311.702 88.5 312.002 89.5 312.102 90.7C312.202 91.9 312.102 93.4 311.802 95.3C310.402 104.6 308.602 114.5 306.602 124.8C304.502 135.2 302.202 145.1 299.602 154.6C298.702 157.6 297.602 159.6 296.302 160.8C295.002 161.9 293.002 162.5 290.202 162.4C289.202 162.5 288.202 162.4 287.002 162.2C285.802 162 284.702 161.9 283.602 161.7C282.702 161.6 281.702 161.4 280.902 161.3C279.902 161.1 279.102 160.9 278.402 160.7ZM277.902 130C278.702 126.1 279.502 122 280.402 117.9C281.202 113.8 282.002 109.6 282.702 105.6C281.302 104.8 279.802 104 278.202 103.3C276.602 102.6 274.702 102.1 272.602 101.8C269.502 101.3 266.602 101.6 263.902 102.7C261.202 103.7 258.902 105.2 256.902 107C254.902 108.8 253.302 110.9 252.002 113.2C250.802 115.5 250.002 117.7 249.702 119.7C249.102 123.7 249.802 127 251.802 129.6C253.802 132.3 257.002 133.9 261.402 134.6C264.002 135 266.702 134.8 269.502 134.1C272.302 133.4 275.102 132 277.902 130Z",
    fill: "#E5225C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M344.1 194.8L338.1 187.6C337.3 186.6 336 186.1 334.8 186.3L325.5 187.2C322.3 187.5 320.2 184 321.9 181.3L326.8 173.3C327.5 172.2 327.6 170.9 327.1 169.7L323.3 161.1C322 158.2 324.6 155.1 327.7 155.8L336.8 158C338 158.3 339.3 158 340.3 157.1L347.3 150.9C349.7 148.8 353.5 150.3 353.7 153.5L354.4 162.9C354.5 164.2 355.2 165.3 356.3 165.9L364.4 170.6C367.2 172.2 366.9 176.3 363.9 177.5L355.2 181C354 181.5 353.2 182.5 352.9 183.7L350.9 192.9C350.1 196.2 346.2 197.2 344.1 194.8Z",
    fill: "#FFE629"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M314.3 308.5L299.2 272.6C298.8 271.7 297.6 271.3 296.8 271.9L277.2 284.7C270.7 288.9 268.7 297.9 271.8 305.3C274.9 312.7 282.7 317.5 290.3 315.8L313.2 310.7C314.1 310.6 314.7 309.5 314.3 308.5Z",
    fill: "url(#paint9_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M309.617 302.015L316.676 298.939L307.208 277.213L300.149 280.289L309.617 302.015Z",
    fill: "#D5C691"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M309.581 302.076L313.248 300.478L303.78 278.752L300.113 280.35L309.581 302.076Z",
    fill: "#A5986E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M307 282.1L313.3 296.1C315.3 300.7 320.7 302.7 325.2 300.7L342.5 292.9C347.1 290.9 349.1 285.5 347.1 281L340.8 267C338.8 262.4 333.4 260.4 328.9 262.4L311.6 270.2C307 272.2 304.9 277.6 307 282.1Z",
    fill: "url(#paint10_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M308.698 284.1C308.698 284.1 304.498 279.8 304.998 275.9C305.498 272 307.298 258 307.698 255.4C308.498 250.3 313.698 247.7 316.998 253.3C319.598 257.7 320.898 269 319.098 272.6C317.198 276.2 308.698 284.1 308.698 284.1Z",
    fill: "url(#paint11_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M330.899 283.6C333.999 281.8 337.099 279.8 339.799 278.5C340.899 278 342.199 278.5 342.699 279.6L343.199 280.8C344.699 284.3 343.199 288.5 339.699 290L322.999 297.6C319.499 299.2 315.499 297.6 313.999 294.1L312.399 290.4C311.099 287.5 312.999 284.2 316.099 283.8C321.699 283.1 326.199 286.4 330.899 283.6Z",
    fill: "url(#paint12_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M276.999 284.8C276.399 288.1 276.799 291.7 278.199 295C281.299 302.4 289.099 307.2 296.699 305.5L311.599 302.2L313.999 308C314.499 309.2 313.799 310.6 312.499 310.9L290.199 315.8C282.599 317.5 274.799 312.6 271.699 305.3C268.599 297.9 270.599 289 276.999 284.8Z",
    fill: "#5A95B7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M304 289.9L297.8 276.8C297.3 275.8 296.1 275.4 295.1 276.1L282.6 284.3C281.2 285.2 281.6 287.3 283.2 287.6C288.2 288.6 293.6 288.7 301.6 292.5C303.2 293.1 304.7 291.4 304 289.9Z",
    fill: "url(#paint13_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M343.7 257.1C342.8 256.2 341.2 256.4 339.6 256.5C338.3 256.6 337 256.9 335.6 257.5C333.7 258.3 331.7 259.3 330.1 260.5C329.5 261 329 261.8 328.7 262.5C328.1 263.8 327.4 265.6 328.4 268.9C330.5 276.1 336 286.6 338 289.6C341 294 352.8 290.2 354.7 284.2C356.6 278.3 348 261.1 343.7 257.1Z",
    fill: "url(#paint14_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M343.7 257.2C341.1 254.7 330.4 258.7 328.6 262C327.4 264.3 327.5 270.8 331.2 276.3C334.9 281.8 334 271.1 337.2 263.1C339 258.9 343.7 257.2 343.7 257.2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M314.3 308.5L299.2 272.6C298.8 271.7 297.6 271.3 296.8 271.9L277.2 284.7C270.7 288.9 268.7 297.9 271.8 305.3C274.9 312.7 282.7 317.5 290.3 315.8L313.2 310.7C314.1 310.6 314.7 309.5 314.3 308.5Z",
    fill: "url(#paint15_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M309.617 302.015L316.676 298.939L307.208 277.213L300.149 280.289L309.617 302.015Z",
    fill: "#D5C691"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M309.581 302.076L313.248 300.478L303.78 278.752L300.113 280.35L309.581 302.076Z",
    fill: "#A5986E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M307 282.1L313.3 296.1C315.3 300.7 320.7 302.7 325.2 300.7L342.5 292.9C347.1 290.9 349.1 285.5 347.1 281L340.8 267C338.8 262.4 333.4 260.4 328.9 262.4L311.6 270.2C307 272.2 304.9 277.6 307 282.1Z",
    fill: "url(#paint16_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M308.698 284.1C308.698 284.1 304.498 279.8 304.998 275.9C305.498 272 307.298 258 307.698 255.4C308.498 250.3 313.698 247.7 316.998 253.3C319.598 257.7 320.898 269 319.098 272.6C317.198 276.2 308.698 284.1 308.698 284.1Z",
    fill: "url(#paint17_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M330.899 283.6C333.999 281.8 337.099 279.8 339.799 278.5C340.899 278 342.199 278.5 342.699 279.6L343.199 280.8C344.699 284.3 343.199 288.5 339.699 290L322.999 297.6C319.499 299.2 315.499 297.6 313.999 294.1L312.399 290.4C311.099 287.5 312.999 284.2 316.099 283.8C321.699 283.1 326.199 286.4 330.899 283.6Z",
    fill: "url(#paint18_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M276.999 284.8C276.399 288.1 276.799 291.7 278.199 295C281.299 302.4 289.099 307.2 296.699 305.5L311.599 302.2L313.999 308C314.499 309.2 313.799 310.6 312.499 310.9L290.199 315.8C282.599 317.5 274.799 312.6 271.699 305.3C268.599 297.9 270.599 289 276.999 284.8Z",
    fill: "#5A95B7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M304 289.9L297.8 276.8C297.3 275.8 296.1 275.4 295.1 276.1L282.6 284.3C281.2 285.2 281.6 287.3 283.2 287.6C288.2 288.6 293.6 288.7 301.6 292.5C303.2 293.1 304.7 291.4 304 289.9Z",
    fill: "url(#paint19_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M343.7 257.1C342.8 256.2 341.2 256.4 339.6 256.5C338.3 256.6 337 256.9 335.6 257.5C333.7 258.3 331.7 259.3 330.1 260.5C329.5 261 329 261.8 328.7 262.5C328.1 263.8 327.4 265.6 328.4 268.9C330.5 276.1 336 286.6 338 289.6C341 294 352.8 290.2 354.7 284.2C356.6 278.3 348 261.1 343.7 257.1Z",
    fill: "url(#paint20_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M343.7 257.2C341.1 254.7 330.4 258.7 328.6 262C327.4 264.3 327.5 270.8 331.2 276.3C334.9 281.8 334 271.1 337.2 263.1C339 258.9 343.7 257.2 343.7 257.2Z",
    fill: "white"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M102.307 257.003L95.8848 252.755L82.8071 272.52L89.2289 276.769L102.307 257.003Z",
    fill: "#D5C691"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M102.326 256.988L98.9902 254.781L85.9126 274.547L89.2486 276.754L102.326 256.988Z",
    fill: "#A5986E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8984 283.9L105.098 247.2C105.698 246.2 106.998 246 107.898 246.8L127.198 263.9C133.598 269.6 134.298 279.6 129.798 287.2C125.198 294.7 115.998 298.8 107.998 295.7L83.8984 286.5C82.7984 286.2 82.3984 284.9 82.8984 283.9Z",
    fill: "url(#paint21_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M127.3 264C127.4 267.7 126.4 271.5 124.4 274.9C119.8 282.4 110.6 286.5 102.6 283.4L86.8997 277.4L83.2997 283.3C82.4997 284.6 83.0997 286.2 84.4997 286.7L108 295.6C116 298.6 125.2 294.6 129.8 287.1C134.3 279.7 133.6 269.7 127.3 264Z",
    fill: "#5A95B7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M96.9988 265.4L105.799 252.1C106.499 251.1 107.899 250.9 108.799 251.7L121.099 262.6C122.399 263.8 121.699 266 119.899 266.1C114.299 266.4 108.399 265.6 99.0988 268.5C97.3988 269 95.9988 266.9 96.9988 265.4Z",
    fill: "url(#paint22_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M255.299 336.9L133.499 318.4C124.599 317 118.399 308.7 119.799 299.8L123.499 275.2C124.899 266.3 133.199 260.1 142.099 261.5L263.999 280.1C272.899 281.5 279.099 289.8 277.699 298.7L273.999 323.3C272.599 332.1 264.199 338.3 255.299 336.9Z",
    fill: "url(#paint23_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M211.2 292.1C213.6 297.8 195.6 306.2 179.3 303.7C163 301.2 147.7 289.8 152.3 283.1C156.9 276.3 163 286.1 179.3 288.6C195.6 291.1 208.1 284.7 211.2 292.1Z",
    fill: "#212A2F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M260.298 282.8L148.898 265.9C144.098 265.2 139.598 266.7 136.398 269.7C143.498 268.1 157.598 269.6 168.698 271.3C262.598 286.2 277.598 314.1 257.998 333.1C263.898 331.9 268.698 327.3 269.598 321.2L272.898 299.4C274.098 291.4 268.398 284 260.298 282.8Z",
    fill: "url(#paint24_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M254.598 192.3C249.698 192.5 245.198 193.5 240.898 195.2C228.098 200.2 213.498 196.7 204.498 186.3C196.298 176.8 182.298 169.6 158.598 172.2C135.098 174.7 119.198 198.6 120.798 222.1C122.698 250 147.798 270 175.098 266.3C181.098 265.5 186.698 263.6 191.698 260.8C203.898 254.1 218.998 256.3 229.398 265.5C236.098 271.4 245.598 276.1 258.998 277.1C285.298 279.2 303.798 250.7 297.798 225C293.098 205.2 274.798 191.4 254.598 192.3Z",
    fill: "#74B8D7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M262.199 256.3C248.799 255.2 239.299 250.6 232.599 244.7C222.199 235.5 207.099 233.3 194.899 240C189.899 242.8 184.299 244.7 178.299 245.5C150.999 249.3 125.999 229.3 123.999 201.3C123.999 201.1 123.999 200.9 123.999 200.7C121.399 207.4 120.199 214.8 120.699 222.1C122.599 250 147.699 270 174.999 266.3C180.999 265.5 186.599 263.6 191.599 260.8C203.799 254.1 218.899 256.3 229.299 265.5C235.999 271.4 245.499 276.1 258.899 277.1C282.899 279 300.499 255.3 298.699 231.6C292.599 246.5 278.999 257.6 262.199 256.3Z",
    fill: "#518EB7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M163 176.6C140.1 179.8 124.1 200.9 127.3 223.8C130.5 246.7 151.6 262.7 174.5 259.5C197.4 256.3 213.4 235.2 210.2 212.3C207 189.4 185.9 173.4 163 176.6ZM173.1 249.2C155.9 251.6 140 239.6 137.6 222.4C135.2 205.2 147.2 189.3 164.4 186.9C181.6 184.5 197.5 196.5 199.9 213.7C202.3 230.9 190.3 246.8 173.1 249.2Z",
    fill: "#97BED4",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M169.199 250.7C186.872 250.7 201.199 236.373 201.199 218.7C201.199 201.027 186.872 186.7 169.199 186.7C151.526 186.7 137.199 201.027 137.199 218.7C137.199 236.373 151.526 250.7 169.199 250.7Z",
    fill: "#EBEBE9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M165.199 189.7C182.199 187.3 197.999 198.9 201.099 215.6C201.099 215.1 200.999 214.7 200.899 214.2C198.499 196.7 182.299 184.5 164.799 186.9C147.299 189.3 135.099 205.5 137.499 223C137.599 223.5 137.599 223.9 137.699 224.4C136.099 207.5 148.199 192.1 165.199 189.7Z",
    fill: "#A9A9A9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M169.3 245C183.493 245 195 233.494 195 219.3C195 205.106 183.493 193.6 169.3 193.6C155.106 193.6 143.6 205.106 143.6 219.3C143.6 233.494 155.106 245 169.3 245Z",
    fill: "#AAD1DD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116.094,
    y: 165.533,
    width: 107,
    height: 107,
    fill: "url(#pattern0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M169.299 229.4C174.877 229.4 179.399 224.878 179.399 219.3C179.399 213.722 174.877 209.2 169.299 209.2C163.721 209.2 159.199 213.722 159.199 219.3C159.199 224.878 163.721 229.4 169.299 229.4Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M158.499 216.5C162.751 216.5 166.199 213.053 166.199 208.8C166.199 204.547 162.751 201.1 158.499 201.1C154.246 201.1 150.799 204.547 150.799 208.8C150.799 213.053 154.246 216.5 158.499 216.5Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M178.2 235.9C180.243 235.9 181.9 234.243 181.9 232.2C181.9 230.156 180.243 228.5 178.2 228.5C176.157 228.5 174.5 230.156 174.5 232.2C174.5 234.243 176.157 235.9 178.2 235.9Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M181.399 238.7C182.338 238.7 183.099 237.939 183.099 237C183.099 236.061 182.338 235.3 181.399 235.3C180.46 235.3 179.699 236.061 179.699 237C179.699 237.939 180.46 238.7 181.399 238.7Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M252.799 203.2C235.299 205.6 223.099 221.8 225.499 239.3C227.899 256.8 244.099 269 261.599 266.6C279.099 264.2 291.299 248 288.899 230.5C286.399 213 270.299 200.8 252.799 203.2ZM260.499 258.8C247.299 260.6 235.199 251.4 233.399 238.3C231.599 225.1 240.799 213 253.899 211.2C267.099 209.4 279.199 218.6 280.999 231.7C282.799 244.8 273.599 257 260.499 258.8Z",
    fill: "#97BED4",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5 259.9C271.031 259.9 282 248.931 282 235.4C282 221.869 271.031 210.9 257.5 210.9C243.969 210.9 233 221.869 233 235.4C233 248.931 243.969 259.9 257.5 259.9Z",
    fill: "#EBEBE9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M254.399 213.3C267.399 211.5 279.499 220.3 281.899 233.2C281.899 232.8 281.799 232.5 281.799 232.1C279.899 218.7 267.599 209.3 254.199 211.2C240.799 213.1 231.399 225.4 233.299 238.8C233.299 239.2 233.399 239.5 233.499 239.9C232.199 226.8 241.399 215.1 254.399 213.3Z",
    fill: "#A9A9A9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M257.598 255.7C268.478 255.7 277.298 246.88 277.298 236C277.298 225.12 268.478 216.3 257.598 216.3C246.718 216.3 237.898 225.12 237.898 236C237.898 246.88 246.718 255.7 257.598 255.7Z",
    fill: "#AAD1DD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 208.094,
    y: 186.533,
    width: 99,
    height: 99,
    fill: "url(#pattern1)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M257.598 243.7C261.851 243.7 265.298 240.253 265.298 236C265.298 231.747 261.851 228.3 257.598 228.3C253.346 228.3 249.898 231.747 249.898 236C249.898 240.253 253.346 243.7 257.598 243.7Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M249.298 233.8C252.557 233.8 255.198 231.158 255.198 227.9C255.198 224.641 252.557 222 249.298 222C246.04 222 243.398 224.641 243.398 227.9C243.398 231.158 246.04 233.8 249.298 233.8Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M264.999 249.3C266.546 249.3 267.799 248.046 267.799 246.5C267.799 244.954 266.546 243.7 264.999 243.7C263.453 243.7 262.199 244.954 262.199 246.5C262.199 248.046 263.453 249.3 264.999 249.3Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M163 176.6C140.1 179.8 124.1 200.9 127.3 223.8C130.5 246.7 151.6 262.7 174.5 259.5C197.4 256.3 213.4 235.2 210.2 212.3C207 189.4 185.9 173.4 163 176.6ZM173.1 249.2C155.9 251.6 140 239.6 137.6 222.4C135.2 205.2 147.2 189.3 164.4 186.9C181.6 184.5 197.5 196.5 199.9 213.7C202.3 230.9 190.3 246.8 173.1 249.2Z",
    fill: "#97BED4",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M148.3 241.9C142.7 237.1 138.7 230.3 137.6 222.3C135.2 205.1 147.2 189.2 164.4 186.8C170.5 186 176.4 186.9 181.6 189.2C185.2 187.1 189 185.3 193.1 183.9C184.7 177.9 174.1 175 163.1 176.5C140.2 179.7 124.2 200.8 127.4 223.7C129.3 237.1 137.3 248.1 148.2 254.3C147.8 250.2 147.9 246 148.3 241.9Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M241.999 254.3C237.699 250.5 234.599 245.2 233.799 238.9C231.899 225.4 241.099 213 254.299 211.2C258.899 210.6 263.499 211.3 267.399 213.2C270.199 211.5 273.099 210.2 276.199 209.1C269.799 204.4 261.599 202 253.199 203.2C235.699 205.6 223.499 222.1 225.999 240.1C227.499 250.6 233.599 259.3 241.999 264.2C241.699 260.8 241.699 257.5 241.999 254.3Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M262.199 256.3C248.799 255.2 239.299 250.6 232.599 244.7C222.199 235.5 207.099 233.3 194.899 240C189.899 242.8 184.299 244.7 178.299 245.5C150.999 249.3 125.999 229.3 123.999 201.3C123.999 201.1 123.999 200.9 123.999 200.7C121.399 207.4 120.199 214.8 120.699 222.1C122.599 250 147.699 270 174.999 266.3C180.999 265.5 186.599 263.6 191.599 260.8C203.799 254.1 218.899 256.3 229.299 265.5C235.999 271.4 245.499 276.1 258.899 277.1C282.899 279 300.499 255.3 298.699 231.6C292.599 246.5 278.999 257.6 262.199 256.3Z",
    fill: "#518EB7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M255.199 329.9C254.999 331.5 248.399 331.9 240.599 330.7C232.799 329.5 226.599 327.2 226.899 325.6C227.099 324 233.699 323.6 241.499 324.8C249.299 326 255.499 328.3 255.199 329.9Z",
    fill: "url(#paint25_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.9 329.9C254.7 331.2 250.9 331.7 246.4 331C241.9 330.3 238.4 328.7 238.6 327.5C238.8 326.3 242.6 325.7 247.1 326.4C251.6 327 255.1 328.6 254.9 329.9Z",
    fill: "url(#paint26_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7988 257.7L86.2988 270.1C82.8988 275.8 79.1988 277 75.5988 274.7L62.0988 266.3C58.3988 264 54.6988 260.6 56.6988 254.8L63.7988 238.3C65.7988 232.6 71.0988 229.8 74.6988 232.1L91.7988 243.1C95.3988 245.5 96.7988 252 94.7988 257.7Z",
    fill: "url(#paint27_linear)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7989 257.7C94.7989 257.7 98.1989 252.5 96.6989 248.9C95.1989 245.2 96.9989 227.2 95.9989 224.8C93.9989 220 88.2989 218.8 86.4989 225C84.9989 229.9 80.7989 245.4 83.3989 248.4C86.0989 251.4 94.7989 257.7 94.7989 257.7Z",
    fill: "url(#paint28_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M70.7989 250.6C68.1989 247.9 65.6989 245 63.3989 243C62.4989 242.2 61.0989 242.8 60.2989 244.4L59.4989 246.1C57.1989 250.9 55.1989 254.3 58.1989 256.6L75.0989 270.5C78.0989 272.9 82.3989 270.9 84.6989 266.1L87.1989 261.1C89.0989 257.2 88.0989 252.4 85.1989 251.8C79.8989 250.5 74.7989 254.8 70.7989 250.6Z",
    fill: "url(#paint29_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0991 226.7C64.1991 225.7 65.9992 225.8 67.8992 226C69.3992 226.1 70.8991 226.5 72.4991 227.1C74.7991 228 76.9992 229.1 78.8992 230.6C79.5992 231.2 80.0991 232.2 80.4991 232.9C81.1992 234.4 81.9991 236.5 80.8992 240.3C78.4992 248.7 71.9991 260.9 69.6991 264.4C66.2991 269.5 52.4991 265.1 50.2991 258.2C47.9991 251.3 57.9991 231.3 63.0991 226.7Z",
    fill: "url(#paint30_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.0996 226.8C66.0996 223.9 78.5996 228.5 80.5996 232.4C81.9996 235.1 81.7996 242.7 77.4996 249C73.1996 255.3 74.1996 242.9 70.4996 233.7C68.5996 228.8 63.0996 226.8 63.0996 226.8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M102.307 257.003L95.8848 252.755L82.8071 272.52L89.2289 276.769L102.307 257.003Z",
    fill: "#D5C691"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M102.326 256.988L98.9902 254.781L85.9126 274.547L89.2486 276.754L102.326 256.988Z",
    fill: "#A5986E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8984 283.9L105.098 247.2C105.698 246.2 106.998 246 107.898 246.8L127.198 263.9C133.598 269.6 134.298 279.6 129.798 287.2C125.198 294.7 115.998 298.8 107.998 295.7L83.8984 286.5C82.7984 286.2 82.3984 284.9 82.8984 283.9Z",
    fill: "url(#paint31_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M127.3 264C127.4 267.7 126.4 271.5 124.4 274.9C119.8 282.4 110.6 286.5 102.6 283.4L86.8997 277.4L83.2997 283.3C82.4997 284.6 83.0997 286.2 84.4997 286.7L108 295.6C116 298.6 125.2 294.6 129.8 287.1C134.3 279.7 133.6 269.7 127.3 264Z",
    fill: "#5A95B7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M96.9988 265.4L105.799 252.1C106.499 251.1 107.899 250.9 108.799 251.7L121.099 262.6C122.399 263.8 121.699 266 119.899 266.1C114.299 266.4 108.399 265.6 99.0988 268.5C97.3988 269 95.9988 266.9 96.9988 265.4Z",
    fill: "url(#paint32_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M255.299 336.9L133.499 318.4C124.599 317 118.399 308.7 119.799 299.8L123.499 275.2C124.899 266.3 133.199 260.1 142.099 261.5L263.999 280.1C272.899 281.5 279.099 289.8 277.699 298.7L273.999 323.3C272.599 332.1 264.199 338.3 255.299 336.9Z",
    fill: "url(#paint33_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M211.2 292.1C213.6 297.8 195.6 306.2 179.3 303.7C163 301.2 147.7 289.8 152.3 283.1C156.9 276.3 163 286.1 179.3 288.6C195.6 291.1 208.1 284.7 211.2 292.1Z",
    fill: "#212A2F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M260.298 282.8L148.898 265.9C144.098 265.2 139.598 266.7 136.398 269.7C143.498 268.1 157.598 269.6 168.698 271.3C262.598 286.2 277.598 314.1 257.998 333.1C263.898 331.9 268.698 327.3 269.598 321.2L272.898 299.4C274.098 291.4 268.398 284 260.298 282.8Z",
    fill: "url(#paint34_linear)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M254.598 192.3C249.698 192.5 245.198 193.5 240.898 195.2C228.098 200.2 213.498 196.7 204.498 186.3C196.298 176.8 182.298 169.6 158.598 172.2C135.098 174.7 119.198 198.6 120.798 222.1C122.698 250 147.798 270 175.098 266.3C181.098 265.5 186.698 263.6 191.698 260.8C203.898 254.1 218.998 256.3 229.398 265.5C236.098 271.4 245.598 276.1 258.998 277.1C285.298 279.2 303.798 250.7 297.798 225C293.098 205.2 274.798 191.4 254.598 192.3Z",
    fill: "#74B8D7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M262.199 256.3C248.799 255.2 239.299 250.6 232.599 244.7C222.199 235.5 207.099 233.3 194.899 240C189.899 242.8 184.299 244.7 178.299 245.5C150.999 249.3 125.999 229.3 123.999 201.3C123.999 201.1 123.999 200.9 123.999 200.7C121.399 207.4 120.199 214.8 120.699 222.1C122.599 250 147.699 270 174.999 266.3C180.999 265.5 186.599 263.6 191.599 260.8C203.799 254.1 218.899 256.3 229.299 265.5C235.999 271.4 245.499 276.1 258.899 277.1C282.899 279 300.499 255.3 298.699 231.6C292.599 246.5 278.999 257.6 262.199 256.3Z",
    fill: "#518EB7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M163 176.6C140.1 179.8 124.1 200.9 127.3 223.8C130.5 246.7 151.6 262.7 174.5 259.5C197.4 256.3 213.4 235.2 210.2 212.3C207 189.4 185.9 173.4 163 176.6ZM173.1 249.2C155.9 251.6 140 239.6 137.6 222.4C135.2 205.2 147.2 189.3 164.4 186.9C181.6 184.5 197.5 196.5 199.9 213.7C202.3 230.9 190.3 246.8 173.1 249.2Z",
    fill: "#97BED4",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M169.199 250.7C186.872 250.7 201.199 236.373 201.199 218.7C201.199 201.027 186.872 186.7 169.199 186.7C151.526 186.7 137.199 201.027 137.199 218.7C137.199 236.373 151.526 250.7 169.199 250.7Z",
    fill: "#EBEBE9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M165.199 189.7C182.199 187.3 197.999 198.9 201.099 215.6C201.099 215.1 200.999 214.7 200.899 214.2C198.499 196.7 182.299 184.5 164.799 186.9C147.299 189.3 135.099 205.5 137.499 223C137.599 223.5 137.599 223.9 137.699 224.4C136.099 207.5 148.199 192.1 165.199 189.7Z",
    fill: "#A9A9A9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M169.3 245C183.493 245 195 233.494 195 219.3C195 205.106 183.493 193.6 169.3 193.6C155.106 193.6 143.6 205.106 143.6 219.3C143.6 233.494 155.106 245 169.3 245Z",
    fill: "#AAD1DD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 116.094,
    y: 165.533,
    width: 107,
    height: 107,
    fill: "url(#pattern2)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M169.299 229.4C174.877 229.4 179.399 224.878 179.399 219.3C179.399 213.722 174.877 209.2 169.299 209.2C163.721 209.2 159.199 213.722 159.199 219.3C159.199 224.878 163.721 229.4 169.299 229.4Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M158.499 216.5C162.751 216.5 166.199 213.053 166.199 208.8C166.199 204.547 162.751 201.1 158.499 201.1C154.246 201.1 150.799 204.547 150.799 208.8C150.799 213.053 154.246 216.5 158.499 216.5Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M178.2 235.9C180.243 235.9 181.9 234.243 181.9 232.2C181.9 230.156 180.243 228.5 178.2 228.5C176.157 228.5 174.5 230.156 174.5 232.2C174.5 234.243 176.157 235.9 178.2 235.9Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M181.399 238.7C182.338 238.7 183.099 237.939 183.099 237C183.099 236.061 182.338 235.3 181.399 235.3C180.46 235.3 179.699 236.061 179.699 237C179.699 237.939 180.46 238.7 181.399 238.7Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M252.799 203.2C235.299 205.6 223.099 221.8 225.499 239.3C227.899 256.8 244.099 269 261.599 266.6C279.099 264.2 291.299 248 288.899 230.5C286.399 213 270.299 200.8 252.799 203.2ZM260.499 258.8C247.299 260.6 235.199 251.4 233.399 238.3C231.599 225.1 240.799 213 253.899 211.2C267.099 209.4 279.199 218.6 280.999 231.7C282.799 244.8 273.599 257 260.499 258.8Z",
    fill: "#97BED4",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5 259.9C271.031 259.9 282 248.931 282 235.4C282 221.869 271.031 210.9 257.5 210.9C243.969 210.9 233 221.869 233 235.4C233 248.931 243.969 259.9 257.5 259.9Z",
    fill: "#EBEBE9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M254.399 213.3C267.399 211.5 279.499 220.3 281.899 233.2C281.899 232.8 281.799 232.5 281.799 232.1C279.899 218.7 267.599 209.3 254.199 211.2C240.799 213.1 231.399 225.4 233.299 238.8C233.299 239.2 233.399 239.5 233.499 239.9C232.199 226.8 241.399 215.1 254.399 213.3Z",
    fill: "#A9A9A9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M257.598 255.7C268.478 255.7 277.298 246.88 277.298 236C277.298 225.12 268.478 216.3 257.598 216.3C246.718 216.3 237.898 225.12 237.898 236C237.898 246.88 246.718 255.7 257.598 255.7Z",
    fill: "#AAD1DD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 208.094,
    y: 186.533,
    width: 99,
    height: 99,
    fill: "url(#pattern3)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M257.598 243.7C261.851 243.7 265.298 240.253 265.298 236C265.298 231.747 261.851 228.3 257.598 228.3C253.346 228.3 249.898 231.747 249.898 236C249.898 240.253 253.346 243.7 257.598 243.7Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M249.298 233.8C252.557 233.8 255.198 231.158 255.198 227.9C255.198 224.641 252.557 222 249.298 222C246.04 222 243.398 224.641 243.398 227.9C243.398 231.158 246.04 233.8 249.298 233.8Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M264.999 249.3C266.546 249.3 267.799 248.046 267.799 246.5C267.799 244.954 266.546 243.7 264.999 243.7C263.453 243.7 262.199 244.954 262.199 246.5C262.199 248.046 263.453 249.3 264.999 249.3Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M163 176.6C140.1 179.8 124.1 200.9 127.3 223.8C130.5 246.7 151.6 262.7 174.5 259.5C197.4 256.3 213.4 235.2 210.2 212.3C207 189.4 185.9 173.4 163 176.6ZM173.1 249.2C155.9 251.6 140 239.6 137.6 222.4C135.2 205.2 147.2 189.3 164.4 186.9C181.6 184.5 197.5 196.5 199.9 213.7C202.3 230.9 190.3 246.8 173.1 249.2Z",
    fill: "#97BED4",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M148.3 241.9C142.7 237.1 138.7 230.3 137.6 222.3C135.2 205.1 147.2 189.2 164.4 186.8C170.5 186 176.4 186.9 181.6 189.2C185.2 187.1 189 185.3 193.1 183.9C184.7 177.9 174.1 175 163.1 176.5C140.2 179.7 124.2 200.8 127.4 223.7C129.3 237.1 137.3 248.1 148.2 254.3C147.8 250.2 147.9 246 148.3 241.9Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M241.999 254.3C237.699 250.5 234.599 245.2 233.799 238.9C231.899 225.4 241.099 213 254.299 211.2C258.899 210.6 263.499 211.3 267.399 213.2C270.199 211.5 273.099 210.2 276.199 209.1C269.799 204.4 261.599 202 253.199 203.2C235.699 205.6 223.499 222.1 225.999 240.1C227.499 250.6 233.599 259.3 241.999 264.2C241.699 260.8 241.699 257.5 241.999 254.3Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M262.199 256.3C248.799 255.2 239.299 250.6 232.599 244.7C222.199 235.5 207.099 233.3 194.899 240C189.899 242.8 184.299 244.7 178.299 245.5C150.999 249.3 125.999 229.3 123.999 201.3C123.999 201.1 123.999 200.9 123.999 200.7C121.399 207.4 120.199 214.8 120.699 222.1C122.599 250 147.699 270 174.999 266.3C180.999 265.5 186.599 263.6 191.599 260.8C203.799 254.1 218.899 256.3 229.299 265.5C235.999 271.4 245.499 276.1 258.899 277.1C282.899 279 300.499 255.3 298.699 231.6C292.599 246.5 278.999 257.6 262.199 256.3Z",
    fill: "#518EB7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M255.199 329.9C254.999 331.5 248.399 331.9 240.599 330.7C232.799 329.5 226.599 327.2 226.899 325.6C227.099 324 233.699 323.6 241.499 324.8C249.299 326 255.499 328.3 255.199 329.9Z",
    fill: "url(#paint35_linear)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.9 329.9C254.7 331.2 250.9 331.7 246.4 331C241.9 330.3 238.4 328.7 238.6 327.5C238.8 326.3 242.6 325.7 247.1 326.4C251.6 327 255.1 328.6 254.9 329.9Z",
    fill: "url(#paint36_linear)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7988 257.7L86.2988 270.1C82.8988 275.8 79.1988 277 75.5988 274.7L62.0988 266.3C58.3988 264 54.6988 260.6 56.6988 254.8L63.7988 238.3C65.7988 232.6 71.0988 229.8 74.6988 232.1L91.7988 243.1C95.3988 245.5 96.7988 252 94.7988 257.7Z",
    fill: "url(#paint37_linear)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7989 257.7C94.7989 257.7 98.1989 252.5 96.6989 248.9C95.1989 245.2 96.9989 227.2 95.9989 224.8C93.9989 220 88.2989 218.8 86.4989 225C84.9989 229.9 80.7989 245.4 83.3989 248.4C86.0989 251.4 94.7989 257.7 94.7989 257.7Z",
    fill: "url(#paint38_linear)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M70.7989 250.6C68.1989 247.9 65.6989 245 63.3989 243C62.4989 242.2 61.0989 242.8 60.2989 244.4L59.4989 246.1C57.1989 250.9 55.1989 254.3 58.1989 256.6L75.0989 270.5C78.0989 272.9 82.3989 270.9 84.6989 266.1L87.1989 261.1C89.0989 257.2 88.0989 252.4 85.1989 251.8C79.8989 250.5 74.7989 254.8 70.7989 250.6Z",
    fill: "url(#paint39_linear)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0991 226.7C64.1991 225.7 65.9992 225.8 67.8992 226C69.3992 226.1 70.8991 226.5 72.4991 227.1C74.7991 228 76.9992 229.1 78.8992 230.6C79.5992 231.2 80.0991 232.2 80.4991 232.9C81.1992 234.4 81.9991 236.5 80.8992 240.3C78.4992 248.7 71.9991 260.9 69.6991 264.4C66.2991 269.5 52.4991 265.1 50.2991 258.2C47.9991 251.3 57.9991 231.3 63.0991 226.7Z",
    fill: "url(#paint40_linear)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.0996 226.8C66.0996 223.9 78.5996 228.5 80.5996 232.4C81.9996 235.1 81.7996 242.7 77.4996 249C73.1996 255.3 74.1996 242.9 70.4996 233.7C68.5996 228.8 63.0996 226.8 63.0996 226.8Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 152.408,
    y1: 345.661,
    x2: 153.332,
    y2: 285.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 176.74,
    y1: 342.184,
    x2: 126.381,
    y2: 344.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 134.342,
    y1: 328.851,
    x2: 167.667,
    y2: 346.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 154.928,
    y1: 326.649,
    x2: 164.73,
    y2: 287.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 215.365,
    y1: 344.939,
    x2: 198.665,
    y2: 288.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 247.176,
    y1: 345.314,
    x2: 184.284,
    y2: 347.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 194.773,
    y1: 342.426,
    x2: 231.742,
    y2: 335.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 209.66,
    y1: 328.136,
    x2: 193.426,
    y2: 291.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 214.336,
    y1: 354.677,
    x2: 232.306,
    y2: 354.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 314.351,
    y1: 285.527,
    x2: 256.342,
    y2: 321.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 318.131,
    y1: 261.087,
    x2: 334.919,
    y2: 300.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 322.281,
    y1: 268.143,
    x2: 304.232,
    y2: 266.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 324.442,
    y1: 277.164,
    x2: 332.503,
    y2: 295.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 309.929,
    y1: 282.835,
    x2: 275.421,
    y2: 287.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 332.542,
    y1: 252.674,
    x2: 350.392,
    y2: 293.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 314.351,
    y1: 285.527,
    x2: 256.342,
    y2: 321.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 318.131,
    y1: 261.087,
    x2: 334.919,
    y2: 300.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 322.281,
    y1: 268.143,
    x2: 304.232,
    y2: 266.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 324.442,
    y1: 277.164,
    x2: 332.503,
    y2: 295.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 309.929,
    y1: 282.835,
    x2: 275.421,
    y2: 287.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 332.542,
    y1: 252.674,
    x2: 350.392,
    y2: 293.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 86.5981,
    y1: 258.917,
    x2: 143.919,
    y2: 307.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 91.8397,
    y1: 256.692,
    x2: 128.683,
    y2: 267.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 202.936,
    y1: 274.541,
    x2: 194.35,
    y2: 324.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 93.5735,
    y1: 261.552,
    x2: 314.613,
    y2: 323.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 218.983,
    y1: 321.585,
    x2: 263.229,
    y2: 333.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 234.05,
    y1: 325.099,
    x2: 259.481,
    y2: 332.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 86.9264,
    y1: 230.597,
    x2: 67.155,
    y2: 276.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 78.3017,
    y1: 243.881,
    x2: 102.12,
    y2: 235.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 79.177,
    y1: 243.975,
    x2: 65.3535,
    y2: 267.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 76.1479,
    y1: 221.431,
    x2: 55.3891,
    y2: 269.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 86.5981,
    y1: 258.917,
    x2: 143.919,
    y2: 307.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 91.8397,
    y1: 256.692,
    x2: 128.683,
    y2: 267.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 202.936,
    y1: 274.541,
    x2: 194.35,
    y2: 324.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 93.5735,
    y1: 261.552,
    x2: 314.613,
    y2: 323.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 218.983,
    y1: 321.585,
    x2: 263.229,
    y2: 333.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 234.05,
    y1: 325.099,
    x2: 259.481,
    y2: 332.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 86.9264,
    y1: 230.597,
    x2: 67.155,
    y2: 276.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 78.3017,
    y1: 243.881,
    x2: 102.12,
    y2: 235.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 79.177,
    y1: 243.975,
    x2: 65.3535,
    y2: 267.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 76.1479,
    y1: 221.431,
    x2: 55.3891,
    y2: 269.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124597,
    stopColor: "#65A9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85B0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 417.3,
    height: 417.3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAABsCAYAAABtuky0AAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABkCAYAAACSPo4tAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalApproved);
export default __webpack_public_path__ + "static/media/medal-approved.ca31a9c4ee23d1417844a9ebdeee59ac.svg";
export { ForwardRef as ReactComponent };